import PingRequest from './requests/ping-request'
import Exchanger from './exchanger'

class ExchangerApi extends Exchanger {
    constructor(gateway, messageHandler, options, onConnectedCallback, onCloseCallback) {
        super(gateway, messageHandler, options, onConnectedCallback, onCloseCallback);

        this._isPingNeeded = true;
        this._checkPingInterval = null;
    }

    onConnected() {
        super.onConnected();

        var exchanger = this;
        this._checkPingInterval = setInterval(function() {
            if (exchanger._isPingNeeded) {
                exchanger._isPingNeeded = false;
                exchanger.sendRequest(new PingRequest());
            }
            else 
                exchanger._isPingNeeded = true;
        }, 2000);
    }

    onClose() {
        clearInterval(this._checkPingInterval);
        
        super.onClose();
    }

    async onMessage(message) {
        //TODO: set flag only if result === true?
        this._isPingNeeded = false;

        super.onMessage(message);
    }

    async processRequestHandler(requestHandler) {
        this._isPingNeeded = false;

        return await super.processRequestHandler(requestHandler);
    }
}

export default ExchangerApi;